<sabis-ngx-dialog scTitle="Collect Feedback">

  <div modal-body>
    @if (isLoading) {
      <div>Loading...Please Wait</div>
    } @else {
      <sca-card-view cardTitle="Collect Feedback Request">
        <div class="sc-form">
          <!-- Interviewer Email -->
          <div class="sc-form-row">
            <div class="sc-form-control">
              <sabis-ngx-input scType="text" [(ngModel)]="userEmail"
                (ngModelChange)="onUserEmailChanged()"
                scLabel="Email Address"
                name="RefereeEmail">
              </sabis-ngx-input>
            </div>
          </div>
          <!-- email editor -->
        </div>
      </sca-card-view>
    }
    @if (sendEmail) {
      <div>
        <sca-email [email]="email" #emailForm
          [noTemplate]="false"
          [filterEmailTemplates]="true"
          [allowedEmailTemplateIds]="collectFeedbackEmailTemplateIds"
          [canAttachDocuments]="canAttachDocuments"
        [showRecipient]="false"></sca-email>
      </div>
    }
  </div>

  <div modal-footer>
    <!-- send -->
    <sabis-ngx-button (click)="onSaveClick()">
      Send
    </sabis-ngx-button>

    <!-- cancel -->
    <sabis-ngx-button (click)="onCancelClick()">
      Cancel
    </sabis-ngx-button>
  </div>

</sabis-ngx-dialog>

